<template>

  <v-app>
    <component :is="showNavbar" v-if="showMenuBar"></component>
    <!--<v-content class="content-main ">-->
    <v-content class="content-wrapper "
               v-bind:style="[showMenuBar? '':
               {'background-image' : 'url(' + background + ')',
               'background-size': 'cover',
               'background-position': 'center',
               }]">

        <div class="content-main">
          <keep-alive>
            <router-view v-if="keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!keepAlive"></router-view>
        </div>
        <v-snackbar
          class="text-center"
          v-model="snackbar.show"
          :timeout="snackbar.timeout"
          :color="snackbar.color"
          :multi-line="snackbar.multiline"
        >
          {{snackbar.msg}}
        </v-snackbar>
    </v-content>

    <c-alert-dialog
        :open="alert.open"
        :timeout="alert.timeout"
        :title="alert.title"
        :msg="alert.msg"
        :err="alert.err"
        :info="alert.info"
        :confirm="alert.confirm"
        :confirmBoth="alert.confirmBoth"
        :persistent="alert.persistent"
        :callBack="alert.callBack"
        :callBackCancel="alert.callBackCancel"
    />
  </v-app>

</template>

<script>
export default {
  name: 'App',
  components: {
  },

  data: () => ({
  }),
  mounted() {
  },

  computed: {
    showMenuBar() {
      return !(this.$route.path === '/')
    },
    alert() {
      return this.$store.state.alert;
    },
    snackbar() {
      let err = this.$store.state.snackbar.err;
      if(err && err.response && (err.response.status === this.$errorCode.Unauthenticated || err.response.status === this.$errorCode.Forbidden) ) {
        this.$router.push('/');
      }
      return this.$store.state.snackbar;
    },
    keepAlive() {
      return this.$route.meta.keepAlive;
    },
    background() {
      return require(process.env.VUE_APP_BG);
    },
    showNavbar() {
      const component = require(process.env.VUE_APP_NAVBAR);
      return component.default;
    }
  },
  methods: {
  },
};
</script>
<style lang="scss">
@import './styles/index.scss';
.content-wrapper {
  background-color: #f7f7f7;
  /*padding-top: 30px !important;*/
}
.content-main {
  padding: 20px 20px 0px 20px;
  height: 100%;
}
.page-title {
  font-size: 21px;
  font-weight: bold;
  color: #515461;
}

.v-text-field.v-input--dense:not(.v-text-field--outlined):not(.v-text-field--single-line) input, .v-application--is-ltr .v-text-field .v-input__append-inner {
  cursor: initial;
}
</style>
